import { types as coreTypes } from '@sitebuilder/core';

const schema: coreTypes.Schema = {
    downloadBooklet: {
        type: 'boolean',
        title: 'Download Booklet',
        description: '',
    },
};

const dependencies: coreTypes.Schema = {
    downloadBooklet: {
        oneOf: [
            {
                properties: {
                    downloadBooklet: { enum: [true] },
                    downloadBookletButtonText: {
                        type: 'string',
                        title: 'Download button text',
                    },
                    showDownloadBookletIcon: {
                        type: 'boolean',
                        title: 'Download button icon',
                        enum: [true, false],
                        default: false,
                    },
                    downloadBookletMessage: {
                        type: 'string',
                        title: 'Download booklet message',
                        default: 'Downloading booklet may take a few minutes.',
                    },
                    downloadBookletMessageIcon: {
                        type: 'boolean',
                        title: 'Download booklet message icon',
                        enum: [true, false],
                        default: false,
                    },
                    downloadBookletErrorMessage: {
                        type: 'string',
                        title: 'Download booklet error message',
                        default: 'An error occured while generating booklet.',
                    },
                    downloadBookletErrorMessageIcon: {
                        type: 'boolean',
                        title: 'Download booklet error message icon',
                        enum: [true, false],
                        default: false,
                    },
                    downloadLinkText: {
                        type: 'string',
                        title: 'Download booklet link ready text',
                        default: 'Click here',
                    },
                    downloadBookletText: {
                        type: 'string',
                        title: 'Download booklet ready text',
                        default: 'to download pdf.',
                    },
                    bookletName: {
                        type: 'string',
                        title: 'Dowloaded Booklet name',
                    },
                },
                dependencies: {
                    showDownloadBookletIcon: {
                        oneOf: [
                            {
                                properties: {
                                    showDownloadBookletIcon: { enum: [true] },
                                    downloadBookletIconType: {
                                        type: 'string',
                                        title: 'Download button icon type',
                                        enum: ['FontAwesome Icon', 'Image'],
                                        default: 'FontAwesome Icon',
                                    },
                                    downloadBookletIconPosition: {
                                        type: 'string',
                                        title: 'Download button icon position',
                                        enum: ['Left', 'Right'],
                                        default: 'Left',
                                    },
                                },
                                dependencies: {
                                    downloadBookletIconType: {
                                        oneOf: [
                                            {
                                                properties: {
                                                    downloadBookletIconType: {
                                                        enum: ['FontAwesome Icon'],
                                                    },
                                                    downloadBookletIconName: {
                                                        type: 'string',
                                                        title: 'Download Booklet icon name',
                                                        default: 'fa-download',
                                                    },
                                                },
                                            },
                                            {
                                                properties: {
                                                    downloadBookletIconType: {
                                                        enum: ['Image'],
                                                    },
                                                    downloadBookletImage: {
                                                        type: 'string',
                                                        title: 'Download booklet image',
                                                        default: '',
                                                    },
                                                },
                                            },
                                        ],
                                    },
                                },
                            },
                            {
                                properties: {
                                    showDownloadBookletIcon: { enum: [false] },
                                },
                            },
                        ],
                    },
                    downloadBookletMessageIcon: {
                        oneOf: [
                            {
                                properties: {
                                    downloadBookletMessageIcon: { enum: [true] },
                                    downloadBookletMessageIconType: {
                                        type: 'string',
                                        title: 'Download booklet message icon type',
                                        enum: ['FontAwesome Icon', 'Image'],
                                        default: 'FontAwesome Icon',
                                    },
                                    downloadBookletMessageIconPosition: {
                                        type: 'string',
                                        title: 'Download booklet message icon position',
                                        enum: ['Left', 'Right'],
                                        default: 'Left',
                                    },
                                },
                                dependencies: {
                                    downloadBookletMessageIconType: {
                                        oneOf: [
                                            {
                                                properties: {
                                                    downloadBookletMessageIconType: {
                                                        enum: ['FontAwesome Icon'],
                                                    },
                                                    downloadBookletMessageIconName: {
                                                        type: 'string',
                                                        title: 'Download booklet message icon name',
                                                        default:
                                                            'fas fa-circle-notch fa-spin fa-xs',
                                                    },
                                                },
                                            },
                                            {
                                                properties: {
                                                    downloadBookletMessageIconType: {
                                                        enum: ['Image'],
                                                    },
                                                    downloadBookletMessageImage: {
                                                        type: 'string',
                                                        title: 'Download booklet message image',
                                                        default: '',
                                                    },
                                                },
                                            },
                                        ],
                                    },
                                },
                            },
                            {
                                properties: {
                                    downloadBookletMessageIcon: { enum: [false] },
                                },
                            },
                        ],
                    },
                    downloadBookletErrorMessageIcon: {
                        oneOf: [
                            {
                                properties: {
                                    downloadBookletErrorMessageIcon: { enum: [true] },
                                    downloadBookletErrorMessageIconType: {
                                        type: 'string',
                                        title: 'Download booklet error message icon type',
                                        enum: ['FontAwesome Icon', 'Image'],
                                        default: 'FontAwesome Icon',
                                    },
                                    downloadBookletErrorMessageIconPosition: {
                                        type: 'string',
                                        title: 'Download booklet error message icon position',
                                        enum: ['Left', 'Right'],
                                        default: 'Left',
                                    },
                                },
                                dependencies: {
                                    downloadBookletErrorMessageIconType: {
                                        oneOf: [
                                            {
                                                properties: {
                                                    downloadBookletErrorMessageIconType: {
                                                        enum: ['FontAwesome Icon'],
                                                    },
                                                    downloadBookletErrorMessageIconName: {
                                                        type: 'string',
                                                        title: `Download booklet error 
                                                        message icon name`,
                                                        default: 'fas fa-exclamation-circle',
                                                    },
                                                },
                                            },
                                            {
                                                properties: {
                                                    downloadBookletErrorMessageIconType: {
                                                        enum: ['Image'],
                                                    },
                                                    downloadBookletErrorMessageImage: {
                                                        type: 'string',
                                                        title: `Download booklet 
                                                        error message image`,
                                                        default: '',
                                                    },
                                                },
                                            },
                                        ],
                                    },
                                },
                            },
                        ],
                    },
                },
            },
            {
                properties: {
                    downloadBooklet: { enum: [false] },
                },
            },
        ],
    },
};

const uiSchema = {
    'ui:order': [
        'downloadBooklet',
        'downloadBookletButtonText',
        'showDownloadBookletIcon',
        'downloadBookletIconType',
        'downloadBookletIconPosition',
        'downloadBookletIconName',
        'downloadBookletImage',
        'downloadBookletMessage',
        'downloadBookletMessageIcon',
        'downloadBookletMessageIconType',
        'downloadBookletMessageIconPosition',
        'downloadBookletMessageIconName',
        'downloadBookletMessageImage',
        'downloadBookletErrorMessage',
        'downloadBookletErrorMessageIcon',
        'downloadBookletErrorMessageIconType',
        'downloadBookletErrorMessageIconPosition',
        'downloadBookletErrorMessageIconName',
        'downloadBookletErrorMessageImage',
        'downloadLinkText',
        'downloadBookletText',
        'bookletName',
        '*',
    ],
    downloadBooklet: { 'ui:widget': 'CustomCheckbox' },
    downloadBookletButtonText: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{ }}' },
    showDownloadBookletIcon: { 'ui:widget': 'CustomCheckbox' },
    downloadBookletMessage: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{ }}' },
    // downloadBookletMessageIcon: { 'ui:widget': 'CustomCheckbox' },
    downloadBookletErrorMessage: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{ }}' },
    downloadBookletErrorMessageIcon: { 'ui:widget': 'CustomCheckbox' },
    downloadLinkText: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{ }}' },
    downloadBookletText: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{ }}' },
    bookletName: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{ }}' },
    downloadBookletIconType: { 'ui:widget': 'CustomSelect' },
    downloadBookletIconPosition: { 'ui:widget': 'CustomSelect' },
    downloadBookletIconName: { 'ui:widget': 'CustomTextInput' },
    downloadBookletImage: {
        'ui:placeholder': 'https://',
        'ui:widget': 'MediaPicker',
        'ui:options': {
            isImagePicker: true,
        },
    },
    downloadBookletMessageIconType: { 'ui:widget': 'CustomSelect' },
    downloadBookletMessageIconPosition: { 'ui:widget': 'CustomSelect' },
    downloadBookletMessageIconName: {
        'ui:widget': 'CustomTextInput',
    },
    downloadBookletMessageImage: {
        'ui:placeholder': 'https://',
        'ui:widget': 'MediaPicker',
        'ui:options': {
            isImagePicker: true,
        },
    },
    downloadBookletErrorMessageIconType: { 'ui:widget': 'CustomSelect' },
    downloadBookletErrorMessageIconPosition: { 'ui:widget': 'CustomSelect' },
    downloadBookletErrorMessageIconName: {
        'ui:widget': 'ResourcePicker',
        'ui:placeholder': '{{ }}',
    },
    downloadBookletErrorMessageImage: {
        'ui:placeholder': 'https://',
        'ui:widget': 'MediaPicker',
        'ui:options': {
            isImagePicker: true,
        },
    },
};

const downloadSchema = {
    schema,
    uiSchema,
    dependencies,
};

export default downloadSchema;
